import _get from 'lodash/get';
import { AiMediaKindEnum, useAiIndexableMediaKindsQuery } from 'graphql-common';

// Reads the media kinds the company's AI indexing pipeline can turn into
// searchable text (BE `CompanyPlan.aiIndexableMediaKinds`, derived from the
// plan's hosting region). Gated on `enabled` because the field requires the
// AI_ASSISTANCE plan feature; requesting it without that feature errors, and
// since User -> company -> plan are all non-null in the schema, that error
// would null-propagate through the whole response — hence its own query.
//
// Region-scoped, not user-scoped: it changes only when the company's AI
// hosting region does. Hence cache-first — one fetch per session serves every
// consumer, and remounting a form never refetches.
export default function useAiIndexableMediaKinds(
  enabled: boolean,
): AiMediaKindEnum[] {
  const { data } = useAiIndexableMediaKindsQuery({
    skip: !enabled,
    fetchPolicy: 'cache-first',
  });

  return _get(
    data,
    'whoami.resource.company.plan.aiIndexableMediaKinds',
    [],
  ) as AiMediaKindEnum[];
}
